var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { class: _vm.ulClass },
    _vm._l(_vm.getCmsData, function(menuItem, index) {
      return _c("li", { key: index, class: _vm.liClass }, [
        _c(
          "a",
          {
            class: _vm.aClass,
            attrs: {
              target: _vm.getTarget(menuItem),
              href: _vm.getUrl(menuItem)
            }
          },
          [_vm._v(_vm._s(menuItem.displayName))]
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }